import { autoUpdate, offset, useDismiss, useFloating, useHover, useInteractions } from "@floating-ui/react"
import { Localization } from "@viamap/viamap2-common";
import { useState, useId, useRef, useEffect, forwardRef, ReactNode, Children, ReactElement } from "react"
import { MIBIcon } from "src/componentsUtils/MIBIcon";
import { MITFloatingPortal } from "src/componentsUtils/PortalHelpers";





export function LargeIconBtn({ title, children, onClick, ...props }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const { refs, floatingStyles, context: tooltipContext } = useFloating({
        whileElementsMounted: autoUpdate,
        placement: props["title-placement"],
        open: tooltipOpen,
        middleware: [offset(5)],
        onOpenChange: setTooltipOpen,
    });

    const {
        getFloatingProps: getTooltipFloatingProps
    } = useInteractions([useHover(tooltipContext), useDismiss(tooltipContext)]);



    return (
        <>
            <button onClick={onClick} ref={refs.setReference} className="LargeIconBtn">
                {children}
            </button>
            {Boolean(title && tooltipOpen) &&
                <MITFloatingPortal>
                    <div ref={refs.setFloating} className="GlassButtonToolTip" style={floatingStyles} {...getTooltipFloatingProps()} >
                        {title || "ThisIsToolTIp"}
                    </div>
                </MITFloatingPortal>
            }
        </>
    )
}

export const SmallIconBtn = forwardRef<HTMLButtonElement, { children, title?, onClick?, className?}>(function SmallIconBtn(props: { children, title?, onClick?, className?}, ref) {
    return (
        <button ref={ref} onClick={props.onClick} title={props.title} className={"layerBtn" + (props.className ? ` ${props.className}` : "")}>
            {props.children}
        </button>
    )
})

export function PaddedContainer(props: { children, style?: any }) {
    return (
        <div className="PaddedContainer" style={props.style}>
            {props.children}
        </div>
    )
}

export function VLine({ color }: { color?}) {
    return (
        <div className="VLine" style={color ? { borderBottomColor: color } : {}}></div>
    )
}


type MitCheckBoxProps = Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, "onClick"> & {
    children?: React.ReactNode,
    checked?: boolean,
    indeterminate?: boolean,
    className?: string,
    onClick?: (evt: React.MouseEvent<HTMLInputElement, MouseEvent>, checked: boolean) => any,
}
export function GlassCheckbox({ children, checked, indeterminate, onClick, style, className, ...props }: MitCheckBoxProps) {

    const isControlled = typeof checked === "boolean"

    const [checkedS, setCheckedS] = useState<boolean>(!!checked)
    const [indeterminateS, setIndeterminateS] = useState<boolean>(!!indeterminate)
    const id = useId()
    const ref = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (isControlled) {
            setCheckedS(!!checked || false)
        }
    }, [checked, isControlled])

    useEffect(() => {
        setIndeterminateS(!!indeterminate || false)
    }, [indeterminate])

    useEffect(() => {
        if (ref.current) {
            ref.current.indeterminate = indeterminateS ? true : false
        }
    }, [indeterminateS])

    function handleOnClick(evt: React.MouseEvent<HTMLInputElement, MouseEvent>) {
        const nextChecked = !checkedS

        if (!isControlled) {
            // Uncontrolled: toggle internal state
            setCheckedS(nextChecked)
        }

        // Always clear visual indeterminate state on user interaction
        setIndeterminateS(false)

        onClick?.(evt, nextChecked)
        return false
    }

    function handleOnChange() {
        return
    }

    return (
        <div className={"GlassCheckbox" + (className ? ` ${className}` : "")} style={{ ...style }}>
            <input ref={ref} className={"GlassCheckbox_Input"} disabled={props.disabled} onChange={handleOnChange} onClick={handleOnClick} checked={!!checkedS} {...props} type='checkbox' id={props.id ? props.id : id}></input>
            <span style={{ pointerEvents: "none", touchAction: "none" }} className={"GlassCheckbox_Mark" + ((indeterminateS || checkedS) ? " checked" : "")}>
                {indeterminateS ? <MIBIcon icon="partialChecked" /> : (checkedS ? <MIBIcon icon="checked" /> : null)}
            </span>
            {children ? <label className={"GlassCheckbox_Label"} htmlFor={props.id ? props.id : id} >{children}</label> : null}
        </div>
    )
}

export function GlassInfo({ children, className, ...props }: { children, className?, [key: string]: any }) {
    return (
        <div className={"GlassInfo" + (className ? ` ${className}` : "")} {...props}>
            <span>
                {children}
            </span>
        </div>
    )
}

// MARK: Move to Legend 
export function LegendGrid({ children }) {
    return (
        <div className="LegendGrid" >
            {children}
        </div>
    )
}

export function GlassHorizontalScroll({ children }) {
    return (
        <div className="ssHorizontalScroll" >
            {children}
        </div>
    )
}

export function MenuButton({ children, toolTip, activeArrow = false, active = false, ...props }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const { refs, floatingStyles, context: tooltipContext } = useFloating({
        whileElementsMounted: autoUpdate,
        placement: "right",
        open: tooltipOpen,
        middleware: [offset(10)],
        onOpenChange: setTooltipOpen,
    });
    const {
        getFloatingProps: getTooltipFloatingProps
    } = useInteractions([useHover(tooltipContext), useDismiss(tooltipContext)]);



    const { refs: refs2, floatingStyles: floatingStyles2 } = useFloating({
        placement: "right",
        middleware: [offset(14)],
    });

    return (
        <>
            <button ref={(a) => { refs.setReference(a); refs2.setReference(a) }} {...props} onClick={props.onClick} className={"MenuButton " + props.className} type-title={toolTip} >
                {children}
            </button>
            {(tooltipOpen) &&
                <MITFloatingPortal>
                    <div ref={refs.setFloating} className="GlassToolTip Dark" style={floatingStyles} {...getTooltipFloatingProps()} >
                        {toolTip || "ThisIsToolTIp"}
                    </div>
                </ MITFloatingPortal>
            }
            {(active && activeArrow) &&
                <MITFloatingPortal>
                    <div ref={refs2.setFloating} className="GlassMenuArrow" style={floatingStyles2} {...getTooltipFloatingProps()} >
                    </div>
                </ MITFloatingPortal>}
        </>
    )
}

export function ExtendedMenuButton({ children, toolTip, ...props }) {

    const [tooltipOpen, setTooltipOpen] = useState(false);
    const { refs, floatingStyles, context: tooltipContext } = useFloating({
        whileElementsMounted: autoUpdate,
        placement: "right",
        open: tooltipOpen,
        middleware: [offset(10)],
        onOpenChange: setTooltipOpen,
    });
    const {
        getFloatingProps: getTooltipFloatingProps
    } =
        useInteractions([useHover(tooltipContext), useDismiss(tooltipContext)]);
    //   {getReferenceProps: () => ({}), getFloatingProps: () => ({})}


    return (
        <>
            <button ref={refs.setReference} {...props} onClick={props.onClick} className={"ExtendedMenuButton " + props.className} type-title={toolTip} >
                {children}
            </button>
            {(tooltipOpen) &&
                <MITFloatingPortal>
                    <div ref={refs.setFloating} className="GlassToolTip" style={floatingStyles} {...getTooltipFloatingProps()} >
                        {toolTip || "ThisIsToolTIp"}
                    </div>
                </ MITFloatingPortal>
            }
        </>
    )
}


export function GlassCard(props: { title, children, onClick?, variant?, style?, onDrop?, onDragOver?}) {
    return (
        <div className={"GlassCard " + props.variant} style={props.style} onDrop={props.onDrop} onDragOver={props.onDragOver} >
            <div className="head" onClick={props.onClick} >
                {props.title}
            </div>
            <div className="body" >
                {props.children}
            </div>
        </div>
    )
}

export function GlassStack(props: { children }) {
    return (<div className="GlassStack">
        {props.children}
    </div>)
}

export function GlassContainer(props: { children, title, className?}) {
    const [collapsed, setCollapsed] = useState(true)
    return (<div className={"GlassContainer" + (props.className ? ` ${props.className}` : "")}>
        <div className="head" onClick={() => setCollapsed(!collapsed)}>{props.title}</div>
        {collapsed ? <></> : props.children}
    </div>)
}

export function GlassList(props: { title, children, onClick?, variant?, style?},) {
    return (
        <div className={"GlassList " + props.variant} style={props.style} >
            <div className="head" onClick={props.onClick} >
                {props.title}
            </div>
            <div className="body" >
                {props.children}
            </div>
        </div>
    )
}

export function SidePanelScrolling(props: { children, classname?}) {
    const ref = useRef<HTMLDivElement>(null)
    useEffect(() => {
        if (ref.current) {
            const resize = new ResizeObserver(() => {
                if (ref.current) {
                    const needScroll = ref.current.scrollHeight > ref.current.clientHeight;
                    if (needScroll) {
                        ref.current.classList.add("scroll")
                    } else {
                        ref.current.classList.remove("scroll")
                    }
                }
            })
            resize.observe(ref.current)
            return () => resize.disconnect()
        }
    }, [])

    return (
        <div ref={ref} className={"SidePanelScrolling " + (props.classname ? props.classname : "")}>
            {props.children}
        </div>
    )
}

export function EN(props: { children: ReactNode }) {
    return (props.children)
}

export function DK(props: { children: ReactNode }) {
    return (props.children)
}

export function TranslationInline(props: { children: ReactElement<typeof DK | typeof EN>[] }): ReactElement {
    let lan = Localization.getLanguage();
    const mappedChildren = Children.map(props.children, child => {
        if (lan === "da" && child.type == DK) return child;
        if (lan === "en" && child.type == EN) return child;
        return null;
    }).filter(c => c !== null);
    return <>{mappedChildren ?? null} </>;
}